import { InterviewSession } from "../Interface/Index";
import apiClient from "./api-client.service";

class AIInterviewService {
  private APIBaseUrl: string = "";

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async startAIInterview(sessionId: string, browserFingerprint: string) {
    const paylaod = {
      sessionId,
      browserFingerprint,
    };

    try {
      const response = await apiClient.post(`/interview/start`, paylaod);
      return response.data;
    } catch (error: any) {
      console.error("Error starting AI interview:", error);
    }
  }

  async getQuestionsBySessionId(sessionId: string, browserFingerprint: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview/questions/candidate/${sessionId}?browserFingerprint=${browserFingerprint}`
      );
      const data = response.data;
      return data;
    } catch (error: any) {
      console.error("Error fetching questions by session id:", error);
    }
  }

  async answerSingleQuestion(
    answer: string,
    sessionId: string,
    questionId: string,
    browserFingerprint: string
  ) {
    try {
      const formData = new FormData();
      formData.append("answer", answer);
      const response = await apiClient.put(
        `${this.APIBaseUrl}/interview/${sessionId}/questions/${questionId}/response?browserFingerprint=${browserFingerprint}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      return data;
    } catch (error: any) {
      console.error("Error answering single question:", error);
    }
  }

  async evaluateInterview(sessionId: string, browserFingerprint: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview/${sessionId}/evaluate?browserFingerprint=${browserFingerprint}`
      );
      return response.data;
    } catch (error: any) {
      console.error("Error evaluating interview:", error);
    }
  }

  async updateInterviewSession(sessionId: string, session: InterviewSession) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview/update/${sessionId}`,
        session,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error updating interview session:", error);
    }
  }

  async getSessionToken(sessionId: string, browserFingerprint: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/interview/client/token?sessionId=${sessionId}&browserFingerprint=${browserFingerprint}`
      );
      return response.data;
    } catch (error: any) {
      console.error("Error getting ip address:", error);
    }
  }

  async addActivityLogs(
    sessionId: string,
    session: InterviewSession
  ): Promise<{
    isDisqualified: boolean;
    interviewSession: InterviewSession;
    jobApplication?: any;
  } | null> {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview/${sessionId}/activity-logs`,
        session,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error adding activity logs:", error);
      return null;
    }
  }

  async storePinginfo(sessionId: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/interview/ping/${sessionId}`
      );
      return response.data;
    } catch (error: any) {
      console.error("Error storing ping info:", error);
    }
  }
}

const aiInterviewService = new AIInterviewService();

export default aiInterviewService;
